import services from '../services'
import * as types from './mutation-types'

export const GetIntegrations = ({ commit }) => (
  services.list().then(res => {
    commit(types.SET_INTEGRATIONS, res.data.data)
    return res
  })
)

export const GetIntegration = ({ commit }, id) => (
  services.show(id).then(res => {
    commit(types.SET_INTEGRATION, res.data.data)
    return res
  })
)

export const SaveIntegration = ({ commit }, payload) => (
  services.save(payload).then(res => {
    commit(types.SET_INTEGRATION, res.data.data)
    return res
  })
)

export const RemoveIntegration = (context, id) => (
  services.remove(id)
)

export const ToggleStatus = ({ commit }, id) => (
  services.toggleStatus(id).then(res => {
    commit(types.SET_INTEGRATION, res.data.data)
    return res
  })
)

export const TriggerSync = (context, id) => (
  services.triggerSync(id)
)

export const GetSyncLogs = ({ commit }, { id, params }) => (
  services.syncLogs(id, params).then(res => {
    commit(types.SET_SYNC_LOGS, res.data.data || res.data)
    return res
  })
)

export const TestConnection = (context, id) => (
  services.testConnection(id)
)

export const GetProviders = ({ commit }) => (
  services.getProviders().then(res => {
    commit(types.SET_PROVIDERS, res.data.data)
    return res
  })
)

export const GetAvailableFields = ({ commit }) => (
  services.getAvailableFields().then(res => {
    commit(types.SET_AVAILABLE_FIELDS, res.data.data)
    return res
  })
)
